<template>
  <div class="account-tab-content tab-settings">
    <b-card v-if="!isMobile()" no-body>
      <b-tabs pills card vertical nav-wrapper-class="nav-wrap">
        <b-tab title="My details" active>
          <TabChangeDetails />
        </b-tab>
        <b-tab title="Change password">
          <b-card-text>
            <TabChangePassword />
          </b-card-text>
        </b-tab>
        <b-tab title="Change phone number">
          <b-card-text>
            <TabChangePhone />
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
    <div v-else-if="isMobile()" class="tab-settings__mobile">
      <div
          v-for="(item, index) in listSettings"
          :key="index"
          class="tab-settings__mobile-item"
      >
        <div @click="handleToggleItem(index)" class="tab-settings__mobile-title">{{ item.title }}
          <img
              v-if="item.active"
              class="tab-settings__mobile-title-icon-down"
              src="@/assets/images/account/toggle-close.png"
          />
          <img
              v-if="!item.active"
              class="tab-settings__mobile-title-icon-up"
              src="@/assets/images/account/toggle-open.png"
          />
        </div>
        <hr v-if="item.active">
        <div class="tab-settings__mobile-content">
          <TabChangeDetails
            :is-active-title="false"
            v-if="index === 0 && item.active"
          />
          <TabChangePassword
            :is-active-title="false"
            v-if="index === 1 && item.active"
          />
          <TabChangePhone
            :is-active-title="false"
            v-if="index === 2 && item.active"
          />
        </div>
        <hr>
      </div>
    </div>
  </div>
</template>

<script>
import TabChangeDetails from './details';
import TabChangePassword from './password';
import TabChangePhone from './phone';
export default {
  data() {
    return {
      listSettings: [
        {
          title: 'My details',
          active: false
        },
        {
          title: 'Change password',
          active: false
        },
        {
          title: 'Change phone number',
          active: false
        }
      ]
    }
  },
  components: {
    TabChangeDetails,
    TabChangePassword,
    TabChangePhone
  },
  methods : {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    handleToggleItem(index) {
      this.listSettings.forEach((item, i) => {
        if (i === index) {
          item.active = !item.active;
        }
      })
    }
  }
}
</script>
<style scoped lang="scss" src="@/assets/scss/web/account/_settings.scss"/>
